import React, {Fragment} from "react";
import {Field, Form, Formik} from "formik";
import {useFormModificaSchedulazione} from "./useFormModificaSchedulazione.jsx";
import ModalMsg from "../../../../../components/ModalMsg";
import {useFrequenzaSchedulazione} from "../../../hooks/useFrequenzaSchedulazione";

export default function FormModificaSchedulazione({
                                                      schedulazione,
                                                      formikRef,
                                                  }) {

    const {
        initialFormValues,
        validationSchema,
        onSubmitForm,
        show,
        closeModal,
        modalMsg,
        batch,
        installazioni,
    } = useFormModificaSchedulazione({schedulazione})

    const {
        frequenze,
        giorniSettimana,
        mesi,
    } = useFrequenzaSchedulazione();

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <Formik
                enableReinitialize={true}
                initialValues={initialFormValues}
                innerRef={formikRef}
                validationSchema={validationSchema}
                onSubmit={onSubmitForm}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3 pb-5">
                        <div className="col-md-6">
                            <label htmlFor="id_installazione" className="form-label">Installazione*:</label>
                            <Field as="select"
                                   name="id_installazione"
                                   className={'form-select'}>
                                <option value={""}>Selezionare un'installazione</option>
                                {
                                    installazioni.map((op, index) => {
                                        return <option key={index}
                                                       value={op.id_installazione}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            {errors.id_installazione && touched.id_installazione ? (
                                <div className="cmms-div-err-form">{errors.id_installazione}</div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="id_batch" className="form-label">Batch*:</label>
                            <Field as="select"
                                   name="id_batch"
                                   className={'form-select'}>
                                <option value={""}>Selezionare un batch</option>
                                {
                                    batch.map((op, index) => {
                                        return <option key={index}
                                                       value={op.id_batch}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            {errors.id_batch && touched.id_batch ? (
                                <div className="cmms-div-err-form">{errors.id_batch}</div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="ora_sched" className="form-label">Ora schedulazione*:</label>
                            <Field name="ora_sched" className="form-control" type={'time'} step={'60'}/>
                            {errors.ora_sched && touched.ora_sched ? (
                                <div className="cmms-div-err-form">{errors.ora_sched}</div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="frequenza" className="form-label">Frequenza*:</label>
                            <Field as="select"
                                   name="frequenza"
                                   className={'form-select'}>
                                <option value={""}>Selezionare una frequenza</option>
                                {
                                    frequenze.map((op, index) => {
                                        return <option key={index}
                                                       value={op.id}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            {errors.frequenza && touched.frequenza ? (
                                <div className="cmms-div-err-form">{errors.frequenza}</div>
                            ) : null}
                        </div>
                        {
                            parseInt(values.frequenza || '0') === 2 && (
                                <div className="col-md-6">
                                    <label htmlFor="giorno_settimana" className="form-label">Giorno della
                                        settimana*:</label>
                                    <Field as="select"
                                           name="giorno_settimana"
                                           className={'form-select'}
                                    >
                                        <option value={""}>Selezionare un giorno</option>
                                        {
                                            giorniSettimana.map((op, index) => {
                                                return <option key={index}
                                                               value={op.id}>{op.descrizione}</option>
                                            })
                                        }
                                    </Field>
                                    {errors.giorno_settimana && touched.giorno_settimana ? (
                                        <div className="cmms-div-err-form">{errors.giorno_settimana}</div>
                                    ) : null}
                                </div>
                            )
                        }
                        {
                            parseInt(values.frequenza || '0') === 3 && (
                                <div className="col-md-6">
                                    <label htmlFor="giorno_mese" className="form-label">Giorno del mese*:</label>
                                    <Field
                                        name="giorno_mese"
                                        className={'form-control'}
                                        type={'number'}
                                        min={1}
                                        max={31}
                                    />
                                    {errors.giorno_mese && touched.giorno_mese ? (
                                        <div className="cmms-div-err-form">{errors.giorno_mese}</div>
                                    ) : null}
                                </div>
                            )
                        }
                        {
                            parseInt(values.frequenza || '0') === 4 && (
                                <div className="col-md-6">
                                    <label htmlFor="mese" className="form-label">Mese*:</label>
                                    <Field as="select"
                                           name="mese"
                                           className={'form-select'}>
                                        <option value={""}>Selezionare un mese</option>
                                        {
                                            mesi.map((op, index) => {
                                                return <option key={index}
                                                               value={op.id}>{op.descrizione}</option>
                                            })
                                        }
                                    </Field>
                                    {errors.mese && touched.mese ? (
                                        <div className="cmms-div-err-form">{errors.mese}</div>
                                    ) : null}
                                </div>
                            )
                        }
                    </Form>
                )}
            </Formik>
        </Fragment>
    );
}